// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","main":"qRza0","oppositeGenderLinkWrapper":"fGC+V","brandValues":"_7hvXY"};